import React from "react";
import Styles from "./Styles.module.css";
import Slider7 from "./programsliders/Slider7";
import SkeletonDisplay from "../hooks/skeletonDisplay";

function CommunityResourceCenterandMedicalClinic() {
  return (
    <div>
      <div className={Styles.slider1}>
        <div className={Styles.mainContainer}>
          <SkeletonDisplay>
            <img src="/aboutus/aboutus.png" alt="Curd Africa" />
          </SkeletonDisplay>
          <button>Community Resource Center and Medical Clinic</button>
        </div>
      </div>
      <div style={{ margin: "0 auto" }}>
        <Slider7 />
      </div>
    </div>
  );
}

export default CommunityResourceCenterandMedicalClinic;
